/*
 * @Author: soul(佘家骏) 
 * @Date: 2021-09-14 19:26:25 
 * @Last Modified by: soul(佘家骏)
 * @Last Modified time: 2021-09-14 19:29:29
 */
import Vue from 'vue/dist/vue.js';
import App from './app.vue';
import router from './router';
import config from './config';
import pluginsAct from '@/plugins/act-plugin'; // 基础配置
import Vconsole from 'vconsole'
import yqAnalytics from "yq-analytics" // 监控
import biz from './biz'; // 监控自定义使用方法

Vue.use(pluginsAct);
if (config.openDebug) {
  let vConsole = new Vconsole()
  Vue.use(vConsole)
}
if (config.openYqAnalytics) {
  Vue.prototype.$biz = biz
  yqAnalytics.init({
    appId: "3ff4a5b18fbf4809b02b2b8780ccf2f1",
  });
}
Vue.mixin({
  computed: {
    // 图片oss地址
    imgHost() {
      return this.$config.imgHost
    },
    // api接口公共前缀
    apiHost() {
      return `/${this.$config.apiName}/oop/`
    },
    // 资源版本号
    $OSSVersion() {
      return config.OSSVersion
    }
  },
  methods: {
    /**
     * 埋点事件记录
     * propertyValue 只能有一级属性
     */
    async $event(eventId, propertyValue) {
      this.$biz.handlerYqAnalyticsEvent(eventId, propertyValue)
    },
    /**
     * 埋点页面打开
     * 每个页面无需再单独调用
     */
    async $pageOpen() {
      let propertyValueBaseData = await this.$biz.handlerGetYqAnalyticsPropertyValueBaseData();
      yqAnalytics.pageOpen({
        pageUrl: propertyValueBaseData.pageUrl,
        propertyValue: JSON.stringify(propertyValueBaseData)
      })
    },
    //我要推荐
    goShare() {
      let text = {
        text1: "点击",
        text2: "右上角",
        text3: "推荐好友参与",
        text4: "让你和TA都获得金喜，",
        text5: "快去消息列表看看",
        text6: "会有什么神奇的事情发生吧！",
      };
      this.$modal.share.alert(text).then((res) => {
        if (res == "onSave") {
          this.$goPage("poster");
        }
      });
    }
  },
  created() {
    if (config.openYqAnalytics) {
      try {
        this.$pageOpen();
      } catch (e) {
        console.error(e)
      }
    }
  },
})
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')